import utils from "utils";
import Invoice from "../invoice1/model/Invoice";
class billDetailListCtrl {
    constructor($scope, $uibModal, logger, httpRequest, $state, $stateParams, dictService, globalFn) {
        httpRequest.get_dictByTypeArr(['inv_type', 'is_privilege', 'invoice_nature', 'bill_status', "company_type"]).then((res) => {
            $scope.dictData = res.data.value
            $scope.companyType = res.data.value.company_type;
        })
        const {
            billId
        } = $stateParams;
        $scope.isSplit = $state.current.name.indexOf('spiltdetailList') > -1 ? true : false //是否是拆分页
        $scope.billId = billId; //销售单id
        $scope.detailedPage = 1; //商品/机动车明细列表页码
        $scope.prePage = 1;
        $scope.detailedMaxSize = 5;
        $scope.splitMaxSize = 2000
        $scope.invoicePage = 1; //关联发票列表页码
        $scope.billInfo = {};
        $scope.qryBillDetail = {};
        let cacheBill = {}; //商品明细缓存
        let backUpSales
        $scope.qryBillInvoice = {};
        //拆分页使用的参数
        const oldQryBillDetailList = [] // 备份左侧列表数据
        $scope.splitPage = 1; //拆分页列表页码
        $scope.quota = '' // 开票限额
        $scope.lIsSlected = [] // 左侧选中行数组
        $scope.rIsSlected = [] // 右侧选中后数组
        $scope.invoiceSNList = [] // 发票序号数组
        $scope.invoiceList = [] // 右侧列表数组
        $scope.selectedTotalAmt = 0 // 左侧选中行金额
        $scope.forceDetailFlag = false // 是否强制清单
        $scope.isExpand = false
        $scope.editInvoiceList = [{
                enumName: "专用发票",
                enumCode: "0"
            },
            {
                enumName: "普通发票",
                enumCode: "2"
            },
            {
                enumName: "电子发票",
                enumCode: "51"
            }
        ]
        $scope.taxInclud = [{
                enumCode: "1",
                enumName: "含税"
            },
            {
                enumCode: "0",
                enumName: "不含税"
            }
        ]
        $scope.specList = []
        // 获取规格列表
        function getSpecList() {
            if ($scope.billInfo.extendInfo) {
                const extendInfo = JSON.parse($scope.billInfo.extendInfo) || {}
                $scope.billInfo.rollticketCode = extendInfo.rollticketCode
            }
            httpRequest.get_getSysOrgRollticketSpecList().then((res) => {
                $scope.specList = res.data || []
            })
        }
        //获取销售单详情
        const qryBillInfo = function (billId) {
            httpRequest.get_qryBillInfo(billId).then(res => {
                $scope.billInfo = res.data.value;
                $scope.initBillInfo = JSON.parse(JSON.stringify(res.data.value))
                qryBillDetailList();
                if ($scope.billInfo.invoiceType == "41") {
                    getSpecList()
                }
                if ($scope.billInfo.beforeTaxAmount != null) {
                    $scope.billInfo.beforeTaxAmount = globalFn.selfToFixed(
                        $scope.billInfo.beforeTaxAmount,
                        2
                    );
                }
                if ($scope.billInfo.taxAmount != null) {
                    $scope.billInfo.taxAmount = globalFn.selfToFixed(
                        $scope.billInfo.taxAmount,
                        2
                    );
                }
                if ($scope.billInfo.afterTaxAmount != null) {
                    $scope.billInfo.afterTaxAmount = globalFn.selfToFixed(
                        $scope.billInfo.afterTaxAmount,
                        2
                    );
                }
                if ($scope.billInfo.mergeBillList == null) {
                    $scope.billInfo.mergeBillList = [];
                }
                $scope.billInfo.strMergeBillList = $scope.billInfo.mergeBillList.join(
                    ","
                );
                $scope.initUkeyId = $scope.billInfo.ukeyId;
                if ($scope.isSplit) {
                    get_quota()
                }
            });
        };
        // 获取限额
        function get_quota() {
            if ($scope.billInfo.ukeyId && $scope.billInfo.ukeyId != 0) {
                httpRequest.get_getSysTaxDiskByUkey($scope.billInfo.ukeyId).then((res) => {
                    if ($scope.billInfo.invoiceType == 0) {
                        $scope.quota = res.data.specialQuota
                    } else if ($scope.billInfo.invoiceType == 2) {
                        $scope.quota = res.data.generalQuota
                    } else if ($scope.billInfo.invoiceType == 51) {
                        $scope.quota = res.data.electronicQuota
                    } else if ($scope.billInfo.invoiceType == 41) {
                        $scope.quota = res.data.volumeQuota
                    }
                })
            } else {
                logger.logError('请指定开票点')
            }
        }

        // 数组去重   获取发票序号数组
        function unique5(array) {
            const r = []
            for (let i = 0, l = array.length; i < l; i++) {
                for (let j = i + 1; j < l; j++) {
                    if (array[i] == array[j]) j = ++i
                }
                r.push(array[i])
            }
            return r
        }
        $scope.billCommit = function (item) {
            const {
                billId
            } = item;
            if (item.invoiceType != 12) {
                httpRequest.get_qryAllValidRule().then(res => {
                    utils.loaded()
                    $scope.ruleList = res.data.value;
                    if ($scope.ruleList.length == 1) {
                        httpRequest
                            .get_billCommit(billId, "000000", "销售单提交成功")
                            .then(res => {
                                $state.go("outputManage.FOManage.ovatBill.list");
                            })
                            .error();
                    } else {
                        $scope.item = {
                            flag: 2,
                            billId,
                            ruleList: $scope.ruleList
                        };
                        const modalInstance = $uibModal.open({
                            templateUrl: "ovatBillRuleModalCtrl.html",
                            controller: "splitBillRuleModalCtrl",
                            backdrop: "static",
                            openedClass: "mod-modal mod-modal-lg",
                            resolve: {
                                items1() {
                                    return $scope.item;
                                }
                            }
                        });
                        modalInstance.result.then(
                            () => {
                                $state.go("outputManage.FOManage.ovatBill.list");
                                // queryOvatBillList()
                            },
                            () => {}
                        );
                    }
                }).catch(() => {
                    utils.loaded()
                });
            } else {
                httpRequest
                    .get_billCommit(billId, "000000", "销售单提交成功")
                    .then(() => {
                        utils.loaded()
                        $state.go("outputManage.FOManage.ovatBill.list");
                    }).catch(() => {
                        utils.loaded()
                    });;
            }
        };

        $scope.toBillPreview = function (currentPage) {
            let myherf = window.location.href
            myherf = myherf.substring(0, myherf.indexOf('/#!/'))
            window.open(`${myherf}/#!/billPreview?billId=${billId}&currentPage=${currentPage}`)
        };

        // 带搜索功能的下拉选择框相关方法
        function toSelect2data(list, idfield, textfield) {
            const result = [];
            for (const a in list) {
                const tempdata = {
                    id: "",
                    text: ""
                };
                $.extend(tempdata, list[a]);
                tempdata.id = list[a][idfield];
                tempdata.text = list[a][textfield];
                result.push(tempdata);
            }
            return result;
        }

        $scope.config2 = {
            allowClear: false
        }
        $scope.aS2 = {}
        $scope.config2.data = toSelect2data($scope.userInfo.sysUkeyList, 'ukeyId', 'ukeyName')

        // 确定信息提交校验
        const checkSunInfo = function (info) {
            let checkInfo = info ? info : $scope.billInfo
            if (
                checkInfo.custPhone &&
                !utils.regExpTest(checkInfo.custPhone, "uglyPhone")
            ) {
                logger.logError("电话格式错误");
                return false;
            }
            if (checkInfo.invoiceType == 12) {
                if (checkInfo.creditType == 1 && !checkInfo.custIdentifyNo) {
                    logger.logError("身份证号码/组织机构代码不能为空");
                    return false;
                }
                if (!checkInfo.custName) {
                    logger.logError("购买方名称不能为空");
                    return false;
                }
            }
            if (checkInfo.creditType == 1 && (!globalFn.checkTax(checkInfo.custCreditCode, 1) ||
                    checkInfo.custCreditCode.length > 20)) {
                if (!checkInfo.custCreditCode && checkInfo.invoiceType != 12) {
                    logger.logError("购方信用代码不能为空");
                    return false;
                }
                if (checkInfo.custCreditCode) {
                    logger.logError("购方信用代码必须是6~20位大写字母或数字");
                    return false;
                }
            }
            if (
                !globalFn.isNullVal(checkInfo.custAddress) ||
                !globalFn.isNullVal(checkInfo.custPhone)
            ) {
                var lh = 0;
                if (globalFn.isNullVal(checkInfo.custAddress)) {
                    lh += checkInfo.custPhone.toString().length;
                } else {
                    lh += checkInfo.custAddress.toString().length;
                }
                if (lh < 100 && lh > 0) {
                    console.log("格式正确");
                } else {
                    layer.msg("联系电话+地址总长度不能大于100位");
                    return false;
                }
            }
            if (
                !globalFn.isNullVal(checkInfo.custBank) ||
                !globalFn.isNullVal(checkInfo.custBankAccount)
            ) {
                var lh = 0;
                if (globalFn.isNullVal(checkInfo.custBank)) {
                    lh += checkInfo.custBankAccount.toString().length;
                } else {
                    lh += checkInfo.custBank.toString().length;
                }
                if (lh < 100 && lh > 0) {
                    console.log("格式正确");
                } else {
                    layer.msg("开户行+开户行账户总长度不能大于100位");
                    return false;
                }
            }
            if (checkInfo.custMobile) {
                const regex = /^[0-9]{11}$/;
                const result = regex.test(checkInfo.custMobile);
                if (!result) {
                    logger.logError("手机号码格式错误");
                    return false;
                }
            }
            if (checkInfo.custEmail) {
                let custEmail = checkInfo.custEmail;
                custEmail = custEmail.split(";");
                if (checkInfo.custEmail.length > 100) {
                    logger.logError("邮箱总长度不能大于100位");
                    return false;
                }
                const regex = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                for (var i = 0, len = custEmail.length; i < len; i++) {
                    const result = regex.test(custEmail[i]);
                    if (!result) {
                        logger.logError("邮箱格式错误");
                        return false;
                    }
                }
            }
            if (!globalFn.isNullVal(checkInfo.remark)) {
                var lh = checkInfo.remark.toString().length;
                if (lh < 230 && lh > 0) {
                    console.log("格式正确");
                } else {
                    layer.msg("备注信息错误");
                    return false;
                }
            }
            return true;
        };
        let editRequesting = false;
        // 确定提交编辑
        $scope.updateBill = function (billInfo) {
            if (checkSunInfo()) {
                if (editRequesting) return;
                const a = $scope.billInfo.ukeyId;
                if (a != $scope.initUkeyId) {
                    try {
                        if ($scope.aS2.ukeyId == undefined || $scope.aS2.ukeyId == "") {
                            $scope.billInfo.ukeyId = a;
                        } else {
                            $scope.billInfo.ukeyId = $scope.aS2.ukeyId;
                        }
                    } catch (error) {
                        $scope.billInfo.ukeyId = a;
                    }
                }
                let billDetail = [];
                for (var k in cacheBill) {
                    billDetail = billDetail.concat(cacheBill[k]);
                }
                $scope.billInfo.detail = billDetail;
                if (!checkSaleBill()) return;
                editRequesting = true;
                let extendInfo = {}
                try {
                    extendInfo = JSON.parse($scope.billInfo.extendInfo) || {}
                } catch (error) {
                    console.log(error)
                }
                extendInfo.rollticketCode = $scope.billInfo.rollticketCode
                $scope.billInfo.extendInfo = JSON.stringify(extendInfo)
                if (billInfo) {
                    utils.loading('正在提交')
                }
                httpRequest
                    .post_modBill($scope.billInfo)
                    .then(res => {
                        if (billInfo) {
                            $scope.billCommit(billInfo)
                        } else {
                            logger.logSuccess("信息修改成功")
                            cacheBill = {}
                            qryBillInfo(billId);
                            qryBillDetailList()
                            if ($scope.isSplit) {
                                splitQryBillDetailList()
                                if ($scope.invoiceList.length) {
                                    $scope.rIsSlected = $scope.invoiceList
                                    $scope.recall()
                                }
                            }
                        }
                    }).catch(err => {
                        utils.loaded()
                    })
                    .finally(() => {
                        editRequesting = false;
                    });
            }
        };

        // 分页获取商品明细列表
        const qryBillDetailList = function () {
            const req = {
                pageNum: $scope.detailedPage,
                pageSize: $scope.detailedMaxSize,
                param: billId
            };
            if (cacheBill[$scope.detailedPage] && cacheBill[$scope.detailedPage].length == $scope.detailedMaxSize) {
                $scope.invoice.details = cacheBill[$scope.detailedPage];
                backUpSales = JSON.parse(JSON.stringify($scope.invoice.details))
                // $scope.$apply();
            } else {
                httpRequest.post_qryBillDetailList(req).then(res => {
                    let result = res.data.value.list;
                    if ($scope.saleBillTotal == undefined) {
                        $scope.saleBillTotal = res.data.value.total;
                    }
                    $scope.billInfo.deviation = $scope.billInfo.deviation || 0
                    result.forEach(item => {
                        item.privilegeArr = $scope.dictData["is_privilege"];
                        item.initTaxRate = item.taxRate;
                        item.copyBalance = item.balance;
                        item.copyInvoiceType = $scope.billInfo.invoiceType;
                        // $scope.billInfo.deviation += item.deviation
                        if (item.privilegeType) {
                            item.privilegeTypeArr = [item.privilegeType];
                        }
                        for (var i = 0, len = item.privilegeArr.length; i < len; i++) {
                            if (item.privilegeArr[i].enumCode == item.isPrivilege) {
                                item.privilegeObj = item.privilegeArr[i];
                                break;
                            }
                        }
                    });
                    $scope.billInfo.detail = result;
                    $scope.billInfo.isRed = $scope.billInfo.invoiceNature == 1 ? '1' : ''
                    $scope.billInfo.isBill = true
                    backUpSales = JSON.parse(JSON.stringify(result))
                    $scope.invoice = new Invoice($scope.billInfo);
                    cacheBill[$scope.detailedPage] = $scope.invoice.details;
                    $scope.totalItems1 = res.data.value.total;
                    $scope.detailedPage = ++res.data.value.prePage;
                    $scope.detailedMaxSize = res.data.value.pageSize;
                });
            }
        };

        // 拆分列表获取商品明细列表
        const splitQryBillDetailList = function () {
            const req = {
                pageNum: $scope.splitPage,
                pageSize: $scope.splitMaxSize,
                param: billId,

            }
            httpRequest.post_qryBillDetailList(req).then((res) => {
                $scope.qryBillDetail.list = res.data.value.list
                $scope.splitPage = ++res.data.value.prePage
                $scope.splitMaxSize = res.data.value.pageSize
                angular.copy($scope.qryBillDetail.list, oldQryBillDetailList)
                // flag 1: 整行数据    2: 合并数据     3:拆分数据
                $scope.recall = function () {
                    if ($scope.rIsSlected.length < 1) {
                        logger.logError('请选择要撤回的数据')
                        return
                    }
                    $scope.tb_isAllselected2 = false
                    $scope.tb_isAllselected = false
                    $scope.lIsSlected = []

                    function fn2() {
                        if ($scope.invoiceList.length > 0) {
                            for (let i = 0; i < $scope.invoiceList.length; i++) {
                                for (let j = 0; j < $scope.rIsSlected.length; j++) {
                                    try {
                                        if ($scope.invoiceList[i].billDetailId == $scope.rIsSlected[j].billDetailId) {
                                            $scope.invoiceList.splice(i, 1)
                                            fn2()
                                        }
                                    } catch (error) {
                                        console.log('有错误')
                                    }
                                }
                            }
                        }
                    }

                    function fn3(arr1, arr2) {
                        if (arr1.length > 0) {
                            for (let i = 0; i < arr1.length; i++) {
                                for (let j = 0; j < arr2.length; j++) {
                                    try {
                                        if (arr1[i].billDetailId == arr2[j].billDetailId) {
                                            arr1.splice(i, 1)
                                            fn3(arr1, arr2)
                                        }
                                    } catch (error) {
                                        console.log('有错误')
                                    }
                                }
                            }
                        }
                    }

                    if ($scope.invoiceList.length == $scope.rIsSlected.length) { // 全选撤回
                        $scope.invoiceList = []
                        $scope.rIsSlected = []
                        $scope.lIsSlected = []
                        angular.copy(oldQryBillDetailList, $scope.qryBillDetail.list)
                        for (var key in $scope.qryBillDetail.list) {
                            $scope.qryBillDetail.list[key].selected = false
                        }
                        return
                    }

                    $scope.rIsSlected = (function () {
                        const r = []
                        for (let i = 0, l = $scope.rIsSlected.length; i < l; i++) {
                            for (let j = i + 1; j < l; j++) {
                                if ($scope.rIsSlected[i].billDetailId === $scope.rIsSlected[j].billDetailId) j = ++i
                            }
                            r.push($scope.rIsSlected[i])
                        }
                        return r
                    }())
                    for (const a in $scope.rIsSlected) {
                        if ($scope.rIsSlected[a].flag == 1) {
                            for (var b in oldQryBillDetailList) {
                                if ($scope.rIsSlected.length == 0) {
                                    return
                                }
                                if ($scope.rIsSlected[a].billDetailId == oldQryBillDetailList[b].billDetailId) {
                                    $scope.qryBillDetail.list.push(oldQryBillDetailList[b])
                                    fn2()
                                    // $scope.rIsSlected = []
                                }
                            }
                        } else if ($scope.rIsSlected[a].flag == 2) {
                            for (var b in oldQryBillDetailList) {
                                if ($scope.rIsSlected.length == 0) {
                                    return
                                }
                                for (let i = 0, l = $scope.rIsSlected[a].billDetailIdList.length; i < l; i++) {
                                    if ($scope.rIsSlected[a].billDetailIdList[i] == oldQryBillDetailList[b].billDetailId) {
                                        $scope.qryBillDetail.list.push(oldQryBillDetailList[b])
                                        fn2()
                                        // $scope.rIsSlected = []
                                    }
                                }
                            }
                        } else if ($scope.rIsSlected[a].flag == 3) {
                            var obj = {}
                            angular.copy($scope.rIsSlected[a], obj)

                            function fn3() { // 删除右侧勾选的list
                                for (const c in $scope.invoiceList) {
                                    if ($scope.invoiceList[c].billDetailId == obj.billDetailId) {
                                        $scope.invoiceList.splice(c, 1)
                                        fn3()
                                        // $scope.rIsSlected = []
                                    }
                                }
                            }
                            fn3()
                            // $scope.rIsSlected = []
                            for (const d in oldQryBillDetailList) {
                                if (oldQryBillDetailList[d].billDetailId == obj.billDetailId) {
                                    $scope.qryBillDetail.list.push(oldQryBillDetailList[d])
                                }
                            }
                        }
                    }
                    for (var key in $scope.qryBillDetail.list) {
                        $scope.qryBillDetail.list[key].selected = false
                    }
                    $scope.rIsSlected = []
                }
            })
        }
        // 分页获取发票详情列表 post_qryBillInvoice
        const qryBillInvoice = function () {
            const req = {
                pageNum: $scope.invoicePage,
                pageSize: $scope.maxSize2,
                param: billId
            };

            httpRequest.post_qryBillInvoice(req).then(res => {
                $scope.qryBillInvoice.list = res.data.value.list;

                $scope.totalItems2 = res.data.value.total;
                $scope.invoicePage = ++res.data.value.prePage;
                $scope.maxSize2 = res.data.value.pageSize;
            });
        };
        qryBillInfo(billId);
        qryBillInvoice();
        if ($scope.isSplit) {
            splitQryBillDetailList()
        }
        $scope.detailedPageChanged = function () {
            qryBillDetailList();
        };
        $scope.invoicePageChanged = function () {
            qryBillInvoice();
        };

        function getDeviation(item) {
            let taxamount = 0
            if (item.isTax === '1') { // 含税
                taxamount = parseFloat(item.adValoremTotal * item.taxRate / (1 + parseFloat(item.taxRate)))
                if (item.taxRate == '0.015') {
                    taxamount = parseFloat(item.adValoremTotal / 1.05 * 0.015)
                }
            } else { // 不含税
                taxamount = parseFloat(item.amount * item.taxRate)
                if (item.taxRate == '0.015') {
                    taxamount = parseFloat(item.amount * 0.015 / 1.035)
                }
            }
            const deviation = (taxamount - item.taxAmount)
            $scope.billInfo.deviation = ($scope.billInfo.deviation - item.deviation + deviation).toFixed(4)
            return deviation.toFixed(4)
        }
        $scope.resetBalance = function resetBalance(item) {
            item.deviation = getDeviation(item)
            if (item.balance > item.amount || item.balance > item.adValoremTotal) {
                if ($scope.billInfo.invoiceType != 41 && $scope.saleBillTotal == 1) {
                    item.$balance = 0;
                    item.copyBalance = 0;
                }
            }
            $scope.getTotal(item)
        };
        //获取税率
        function getGoodsInfoTax(goods, invoiceType) {
            const rateReq = {
                taxMergeCode: goods.taxMergeCode,
                invType: invoiceType,
                privilegeType: goods.privilegeType ? encodeURIComponent(goods.privilegeType) : ''
            };
            return httpRequest.get_qryGoodsInfoTax(rateReq).then(res => res.data.value);
        }
        dictService.getAndCache(["zero_tax"]).then(res => {
            $scope.dictionary = res;
        });
        // 选中商品行
        $scope.qryTaxClassInfo = function qryTaxClassInfo($item, goods) {
            goods.fromGoods($item);
            goods.isTax = $scope.invoice.isTax;
            goods.isRed = $scope.billInfo.invoiceNature == 1 ? '1' : ''
            getGoodsInfoTax($item, $scope.invoice.invoiceType).then(reteArr => {
                let selectPrivilegeArr = goods.privilegeArr.filter(
                    item => item.enumCode == goods.isPrivilege
                );
                goods.privilegeObj = selectPrivilegeArr[0];
                getPrivilegeType(goods.taxMergeCode).then(value => {
                    goods.privilegeTypeArr = value.taxSpecialManageList;
                    $scope.getTotal(goods)
                })
                goods.taxRateArrs = reteArr;
                goods.taxRateLoaded = true;
            });
        };
        //获取优惠政策类型
        function getPrivilegeType(taxMergeCode) {
            return httpRequest
                .get_qryTaxClassInfo(taxMergeCode)
                .then(res => res.data.value);
        }

        //是否享受优惠政策切换
        $scope.privilegeChange = function (goods) {
            if (goods.isPrivilege == 0) {
                goods.privilegeType = "";
                getGoodsInfoTax(goods, $scope.billInfo.invoiceType).then(res => {
                    goods.taxRateArrs = res;
                    goods.taxRate = goods.initTaxRate
                    if ($scope.billInfo.invoiceType == 12 && goods.taxRate == 0) {
                        goods.taxRate = res[0]
                    }
                    goods.$taxRate = goods.taxRate;
                    $scope.getTotal(goods)
                });
            } else {
                if (goods.privilegeTypeLoaded) {
                    goods.privilegeType = goods.privilegeTypeArr[0];
                    if ($scope.billInfo.invoiceType == 0) {
                        let arr = goods.privilegeTypeArr.filter(item => item != "不征税" && item != "免税");
                        if (arr.length > 0) {
                            goods.privilegeType = arr[0];
                        }
                    }
                    $scope.privilegeTypeChange(goods);
                } else {
                    getPrivilegeType(goods.taxMergeCode).then(value => {
                        goods.privilegeTypeArr = value.taxSpecialManageList;
                        goods.privilegeType = goods.privilegeTypeArr[0];
                        if ($scope.billInfo.invoiceType == 0) {
                            let arr = goods.privilegeTypeArr.filter(item => item != "不征税" && item != "免税");
                            if (arr.length > 0) {
                                goods.privilegeType = arr[0];
                            }
                        }
                        $scope.privilegeTypeChange(goods);
                    });
                }
            }
        };
        //优惠政策类型切换
        $scope.privilegeTypeChange = function (goods) {
            getGoodsInfoTax(goods, $scope.billInfo.invoiceType).then(res => {
                goods.taxRateArrs = res;
                goods.taxRate = goods.taxRateArrs[0]
                goods.$taxRate = goods.taxRate;
                $scope.getTotal(goods)
            });
        };
        $scope.balanceChange = function (item) {
            if (item.copyBalance < 0 || item.copyBalance * 1 > item.amount * 1) {
                logger.logError("差额征税小于商品不含税金额且大于0！");
                item.copyBalance = item.balance;
                return;
            }

            const regex = /^\d{1,12}(\.\d{0,2})?$/;
            if (!regex.test(item.amount)) {
                logger.logError("商品金额不合法！");
                item.copyBalance = item.balance;
                return;
            }
            item.$balance = item.copyBalance;
            $scope.getTotal(item)
        };
        //保存商品明细行校验
        function checkSaleBill() {
            let arr = $scope.billInfo.detail;
            const mayHasRefinedOil = ['0', '2', '41', '51'].indexOf($scope.billInfo.invoiceType) !== -1
            const refinedOils = arr.filter((item) => {
                return utils.isRefinedOil(item.revenueCode)
            })
            const unRefinedOils = arr.filter((item) => {
                return !!item.revenueCode && !utils.isRefinedOil(item.revenueCode)
            })
            const refinedOilLength = refinedOils.length
            const unRefinedOilLength = unRefinedOils.length
            const isRefinedOil = refinedOilLength > 0
            if (mayHasRefinedOil && isRefinedOil && (unRefinedOilLength > 0)) {
                logger.logError('一张发票不能同时开具成品油与其他商品')
                return false
            }
            for (var i = 0, len = arr.length; i < len; i++) {
                let item = arr[i];
                if (!item.matName) {
                    logger.logError("商品行商品名称不能为空！");
                    return false;
                }
                if (mayHasRefinedOil && isRefinedOil) {
                    if (($scope.billInfo.invoiceType !== '41') && (item.unit !== '吨') && (item.unit !== '升')) {
                        logger.logError('成品油商品，计量单位必为“吨”或“升”')
                        return false
                    }
                    if (!item.quantity || (item.quantity * 1 === 0)) {
                        logger.logError('成品油商品，数量不能为空或0')
                        return false
                    }
                }
                if ((!item.amount || item.amount == 0) && item.lineNature != 1) {
                    logger.logError("商品行金额不能为空或者0");
                    return false;
                }
                if (item.isPrivilege == 1 && !item.privilegeType) {
                    logger.logError("享受优惠政策时优惠政策类型不能为空！");
                    return false;
                }
                if (item.lineNature == 1) {
                    if (item.adValoremTotal > 0 || item.amount > 0) {
                        logger.logError("折扣金额不能大于0！");
                        return false;
                    }
                    if (item.discountNo != -1 && (Math.abs(item.adValoremTotal) > arr[i - 1].adValoremTotal || Math.abs(item.amount) > arr[i - 1].amount)) {
                        logger.logError('折扣金额不能大于商品金额！')
                        return false
                    }
                }
                if ($scope.billInfo.invoiceType == 0 && item.taxRate == 0) {
                    logger.logError("专票税率不能为0！");
                    return false;
                }
                if (
                    $scope.billInfo.invoiceType == 0 &&
                    $scope.billInfo.creditType == 3
                ) {
                    logger.logError("专票购方企业类型不能为个人！");
                    return false;
                }
                //机动车校验
                if ($scope.billInfo.invoiceType == 12) {
                    if (!item.adValoremTotal || $scope.billInfo.adValoremTotal == 0) {
                        logger.logError("含税金额不能为空或者0");
                        return false;
                    }
                    if (!item.extInvoiceParam.vehicleType) {
                        logger.logError("车辆类型不能为空");
                        return false;
                    }
                    if (!item.extInvoiceParam.factoryModel) {
                        logger.logError("厂牌型号不能为空");
                        return false;
                    }
                    if (!item.extInvoiceParam.placeOfOrigin) {
                        logger.logError("产地不能为空");
                        return false;
                    }
                    if (!item.extInvoiceParam.vehicleNumber) {
                        logger.logError("车架号不能为空");
                        return false;
                    }

                }
            }
            return true;
        }

        //折扣金额校验
        // function checkInfoLineNature(no, arr, item, index) {
        //     let discountNo = no
        //     if (discountNo == -1) return 'success'
        //     if ((discountNo == 0 || discountNo == 1) && (Math.abs(item.adValoremTotal) > arr[index - 1].adValoremTotal || Math.abs(item.amount) > arr[index - 1].amount)) {
        //         return '折扣金额不能大于商品金额！'
        //     } else {
        //         let adValoremTotal = 0
        //         let amount = 0
        //         for (let i = 0; i < discountNo; i++) {
        //             const element = arr[index - i - 1]
        //             if(element.lineNature ==1){
        //                 discountNo++
        //             }else{
        //                 adValoremTotal += element.adValoremTotal
        //                 amount += element.amount
        //             }
        //         }
        //         if (Math.abs(item.adValoremTotal) > adValoremTotal || Math.abs(item.amount) > amount) return '折扣金额不能大于商品金额！'
        //     }
        // }
        $scope.setLineNature = function (goods) {
            goods.deviation = getDeviation(goods)
            let goodLine;
            if (goods.discountNo != -1) {
                for (var i = 0, len = $scope.invoice.details.length; i < len; i++) {
                    if (goods.billDetailId == $scope.invoice.details[i].billDetailId) {
                        goodLine = $scope.invoice.details[i - goods.discountNo];
                        break;
                    }
                }
                goods.taxRate = goodLine.taxRate;
                goods.matName = goodLine.matName
            }
            if ($scope.billInfo.isTax == 0) {
                if (goods.amount && goods.taxRate) {
                    goods.taxAmount = globalFn.Mul(goods.taxRate, goods.amount);
                    goods.adValoremTotal = globalFn.Add(goods.amount, goods.taxAmount)
                }
            } else {
                if (goods.taxRate && goods.adValoremTotal) {
                    goods.amount = globalFn
                        .Div(goods.adValoremTotal, globalFn.Add(1, goods.taxRate))
                        .toFixed(2);
                    goods.taxAmount = globalFn
                        .Mul(goods.taxRate, goods.amount)
                        .toFixed(2);
                }
            }
            $scope.getTotal(goods)
        };
        $scope.isTaxChange = function () {
            for (var k in cacheBill) {
                let item = cacheBill[k];
                item.forEach(i => {
                    i.isTax = $scope.billInfo.isTax;
                });
            }
        };

        function Trim(str) {
            return str.replace(/(^\s*)|(\s*$)/g, "");
        }
        $scope.fixedEmail = function () {
            let email = $scope.billInfo.custEmail;
            email = email && Trim(email);
            if (!email) return;
            email = email.replace(/；/g, ";");
            email = email.split(";");
            let newEmail = "";
            email.forEach(item => {
                if (item) newEmail += Trim(item) + ";";
            });
            $scope.billInfo.custEmail = newEmail.substr(0, newEmail.length - 1);
        };
        $scope.carInfoFun = function ($item, item) {
            item.extInvoiceParam.vehicleType = $item.vehicleType
            item.matName = $item.vehicleType
            item.extInvoiceParam.factoryModel = $item.brandmode
            item.extInvoiceParam.placeOfOrigin = $item.place
            item.extInvoiceParam.manufacturer = $item.enterpriseName
            item.extInvoiceParam.vehicleTypeCode = $item.code
            item.revenueCode = $item.taxMergeCode
            item.ownCoding = $item.taxMergeCode
            item.taxMergeCode = $item.taxMergeCode
            item.revenueName = $item.taxShortName
            item.privilegeType = $item.privilegeType
            item.isPrivilege = $item.isPrivilege
            if ($item.taxMergeCode) {
                getGoodsInfoTax($item, 12).then(reteArr => {
                    let selectPrivilegeArr = item.privilegeArr.filter(
                        i => i.enumCode == $item.isPrivilege
                    );
                    item.privilegeObj = selectPrivilegeArr[0];
                    getPrivilegeType($item.taxMergeCode).then(value => {
                        item.privilegeTypeArr = value.taxSpecialManageList;
                    })
                    item.taxRateArrs = reteArr;
                });
            }
            item.taxRate = $item.taxRate
            $scope.vehicleCalc(item)
        }
        // 吨位
        $scope.tonnageIptBlur = function tonnageIptBlur(item) {
            if (!item.extInvoiceParam.tonnage) return
            // 是否正确的数据
            function tonnageCheck(v) {
                v = (v == +v) ? (+v).toFixed(2) : v
                const reg = /^\d{1,5}(\.\d{0,2})?$/ // 8个字符，小数点前5位，后2位
                return reg.test(v)
            }
            if (!tonnageCheck(item.extInvoiceParam.tonnage)) {
                item.extInvoiceParam.tonnage = ''
                logger.logError('吨位不符合规则，请重新输入')
            } else {
                item.extInvoiceParam.tonnage = (+item.extInvoiceParam.tonnage).toFixed(2)
            }
        }
        //车辆明细行计算
        $scope.vehicleCalc = function (item) {
            if (($scope.billInfo.invoiceNature == 1 && item.adValoremTotal > 0) || ($scope.billInfo.invoiceNature != 1 && item.adValoremTotal < 0)) {
                item.adValoremTotal = -1 * item.adValoremTotal
            }
            item.taxAmount = (item.adValoremTotal / (1 + item.taxRate * 1) * item.taxRate).toFixed(2)
            item.amount = item.adValoremTotal - item.taxAmount
            item.price = Math.abs(item.amount)
            item.taxPrice = Math.abs(item.adValoremTotal)
            $scope.getTotal(item)
        }
        //计算合计金额，合计税额价税合计
        $scope.getTotal = function (item) {
            let initItem = backUpSales.filter(i => i.billDetailId == item.billDetailId)[0]
            if (initItem) {
                let adValoremTotalDifference = globalFn.Sub(item.adValoremTotal, initItem.adValoremTotal)
                let amount = item.amount //折扣行不含税金额可能为空
                let initAmount = initItem.amount ? initItem.amount : 0
                if (!item.amount) {
                    amount = globalFn.Div(item.adValoremTotal, globalFn.Add(1, item.taxRate))
                }
                let amountDifference = globalFn.Sub(amount, initAmount)
                $scope.billInfo.afterTaxAmount = globalFn.Add($scope.billInfo.afterTaxAmount, adValoremTotalDifference)
                $scope.billInfo.beforeTaxAmount = globalFn.Add($scope.billInfo.beforeTaxAmount, amountDifference)
                $scope.billInfo.taxAmount = globalFn.Sub($scope.billInfo.afterTaxAmount, $scope.billInfo.beforeTaxAmount)
                backUpSales = JSON.parse(JSON.stringify($scope.invoice.details))
            }
        }
        $scope.taxChange = function (item) {
            item.deviation = getDeviation(item)
            $scope.getTotal(item)
        }
        $scope.changeBuyer = function (item) {
            $scope.billInfo.custName = item.customerName
            $scope.billInfo.custCreditCode = item.creditCode
            $scope.billInfo.custAddress = item.businessAddress
            $scope.billInfo.custBank = item.bank
            $scope.billInfo.creditType = item.taxplayerType
            $scope.billInfo.custMobile = item.mobile
            $scope.billInfo.custEmail = item.email
            $scope.billInfo.custIdentifyNo = item.certificateNo
        }
        /**
         * 拆分页独有方法
         */
        // 自动拆分 get_autoSpiltBill
        $scope.autoSplitBill = function (billId) {
            if (checkSunInfo($scope.initBillInfo)) {
                httpRequest.get_qryAllValidRule().then((res) => {
                    $scope.ruleList = res.data.value
                    if ($scope.ruleList.length == 1) {
                        httpRequest.get_autoSpiltBill(billId, '000000', '自动拆分销售单成功').then((res) => {
                            $state.go('outputManage.FOManage.ovatBill.list')
                        })
                    } else {
                        $scope.item = {
                            flag: 1,
                            billId,
                            ruleList: $scope.ruleList
                        }
                        const modalInstance = $uibModal.open({
                            templateUrl: 'ovatBillRuleModalCtrl.html',
                            controller: 'splitBillRuleModalCtrl',
                            openedClass: 'mod-modal mod-modal-lg',
                            backdrop: 'static',
                            resolve: {
                                items1() {
                                    return $scope.item
                                },
                            },
                        })
                        modalInstance.result.then(() => {
                            // $location.path("/outputManage/ovat/ovatBill/list" ).replace()
                            $state.go('outputManage.FOManage.ovatBill.list')
                        }, () => {

                        })
                    }
                })
            }
        }
        // 全选
        $scope.tb_isAllselected = false
        // 表格行checkSelect 方法
        $scope.tb_itemSelectChange = function (row) {
            $scope.lIsSlected = []
            // 判断总行数 是否全部选中 设置
            let len = 0
            for (const a in $scope.qryBillDetail.list) {
                if ($scope.qryBillDetail.list[a].selected == true) {
                    len++
                    $scope.lIsSlected.push($scope.qryBillDetail.list[a])
                }
            }
            if (len == $scope.qryBillDetail.list.length) {
                $scope.tb_isAllselected = true
            } else {
                $scope.tb_isAllselected = false
            }
        }
        // 表格全选
        $scope.tb_selectAll = function () {
            for (const a in $scope.qryBillDetail.list) {
                $scope.qryBillDetail.list[a].selected = $scope.tb_isAllselected
                if ($scope.tb_isAllselected == true) {
                    $scope.lIsSlected = $scope.qryBillDetail.list
                } else {
                    $scope.lIsSlected = []
                }
            }
        }
        // 按钮滑过
        $scope.dropdown_rowhover = function (row, flag) {
            row.dropdownhover = flag
        }
        // 表格行划过
        $scope.tb_rowhover = function (row, flag) {
            row.mouseenter = flag
        }
        // 全选2
        $scope.tb_isAllselected2 = false
        // 表格行checkSelect 方法
        $scope.tb_itemSelectChange2 = function (row) {
            // 判断总行数 是否全部选中 设置
            $scope.rIsSlected = []
            let len = 0
            for (const a in $scope.invoiceList) {
                if ($scope.invoiceList[a].selected == true) {
                    len++
                    $scope.rIsSlected.push($scope.invoiceList[a])
                }
            }
            if (len == $scope.invoiceList.length) {
                $scope.tb_isAllselected2 = true
            } else {
                $scope.tb_isAllselected2 = false
            }
        }
        // 表格全选
        $scope.tb_selectAll2 = function () {
            for (const a in $scope.invoiceList) {
                $scope.invoiceList[a].selected = $scope.tb_isAllselected2
                if ($scope.tb_isAllselected2 == true) {
                    $scope.rIsSlected = $scope.invoiceList
                } else {
                    $scope.rIsSlected = []
                }
            }
        }
        // 按钮滑过
        $scope.dropdown_rowhover2 = function (row, flag) {
            row.dropdownhover = flag
        }
        // 表格行划过
        $scope.tb_rowhover2 = function (row, flag) {
            row.mouseenter = flag
        }
        // 获取发票序号数组
        function getInvoiceSNList() {
            for (let i = 0, l = $scope.invoiceList.length; i < l; i++) {
                $scope.invoiceSNList.push($scope.invoiceList[i].invoiceSN)
            }
            $scope.invoiceSNList = unique5($scope.invoiceSNList).sort()
        }
        // 左侧数组删除选中数据
        function fn() {
            if ($scope.qryBillDetail.list.length > 0) {
                for (let i = 0; i < $scope.qryBillDetail.list.length; i++) {
                    for (let j = 0; j < $scope.lIsSlected.length; j++) {
                        try {
                            if ($scope.qryBillDetail.list[i].billDetailId == $scope.lIsSlected[j].billDetailId) {
                                $scope.qryBillDetail.list.splice(i, 1)
                                fn()
                            }
                        } catch (error) {
                            console.log('有错误')
                        }
                    }
                }
            }
        }
        // 整行功能
        $scope.fullRow = function () {
            // 获取发票序号列表(未去重)
            getInvoiceSNList()

            if ($scope.lIsSlected.length <= 0) {
                logger.logError('请选择一行或者多行明细进行整行操作')
            } else {
                // 弹出窗  选择或者填写发票序号
                $scope.item = {
                    // invoiceList: $scope.invoiceList,
                    lIsSlected: $scope.lIsSlected,
                    invoiceSNList: $scope.invoiceSNList,
                    status: 1,
                }
                const modalInstance = $uibModal.open({
                    templateUrl: 'chooseInvoiceNoCtrl.html',
                    controller: 'chooseInvoiceNoCtrl',
                    openedClass: 'mod-modal mod-modal-lg',
                    backdrop: 'static',
                    resolve: {
                        items1() {
                            return $scope.item
                        },
                    },
                })
                modalInstance.result.then((lIsSlected) => {
                    $scope.invoiceList = $scope.invoiceList.concat(lIsSlected)
                    fn()
                    $scope.lIsSlected = []
                    $scope.tb_isAllselected = false
                    $scope.tb_isAllselected2 = false
                }, () => {})
            }
        }
        // 拆分
        $scope.split = function () {
            getInvoiceSNList()
            if ($scope.lIsSlected.length == 1) {
                // 弹出窗  选择或者填写发票序号
                $scope.item = {
                    invoiceSNList: $scope.invoiceSNList,
                    singleDetailInfo: $scope.lIsSlected[0],

                }
                const modalInstance = $uibModal.open({
                    templateUrl: 'splitDetailColModCtrl.html',
                    controller: 'splitDetailColModCtrl',
                    openedClass: 'mod-modal-split mod-modal mod-modal-hg',
                    backdrop: 'static',
                    resolve: {
                        items1() {
                            return $scope.item
                        },
                    },
                })
                modalInstance.result.then((invoiceList) => {
                    $scope.invoiceList = $scope.invoiceList.concat(invoiceList)
                    // 左侧数组删除选中数据
                    for (let i = 0; i < $scope.qryBillDetail.list.length; i++) {
                        for (let j = 0; j < $scope.lIsSlected.length; j++) {
                            if ($scope.qryBillDetail.list[i].billDetailId == $scope.lIsSlected[j].billDetailId) {
                                $scope.qryBillDetail.list.splice(i, 1)
                            }
                        }
                    }
                    $scope.lIsSlected = []
                    $scope.tb_isAllselected = false
                    $scope.tb_isAllselected2 = false
                }, () => {


                })
            } else {
                logger.logError('拆分明细只能勾选一行明细进行操作')
            }
        }
        // 合并明细
        $scope.merge = function () {
            // 获取发票序号列表(未去重)
            let isTaxRate = true
            let isMatName = true
            let isSpec = true
            let isUnit = true
            getInvoiceSNList()
            if ($scope.lIsSlected.length < 2) {
                logger.logError('合并明细至少选中两条明细')
            } else {
                for (var a in $scope.lIsSlected) {
                    if ($scope.lIsSlected[0].taxRate != $scope.lIsSlected[a].taxRate) {
                        isTaxRate = false
                    }
                    if ($scope.lIsSlected[0].matName != $scope.lIsSlected[a].matName) {
                        isMatName = false
                    }
                    if ($scope.lIsSlected[0].spec != $scope.lIsSlected[a].spec) {
                        isSpec = false
                    }
                    if ($scope.lIsSlected[0].unit != $scope.lIsSlected[a].unit) {
                        isUnit = false
                    }
                }

                if (isTaxRate && isMatName && isSpec && isUnit) {
                    // 合行 税额误差校验
                    let aftertotleAmount = 0
                    let beforeTotleTaxAmount = 0
                    for (var a in $scope.lIsSlected) {
                        aftertotleAmount += $scope.lIsSlected[a].amount
                        beforeTotleTaxAmount += $scope.lIsSlected[a].taxAmount
                    }
                    const afterTaxAmount = globalFn.Mul(aftertotleAmount, $scope.lIsSlected[0].taxRate)
                    const isTaxAmount = Math.abs(afterTaxAmount - beforeTotleTaxAmount)
                    if (isTaxAmount > 0.06) {
                        logger.logError('合并行误差超过0.06元,不允许合并')
                        return
                    }
                    // 校验结束
                    $scope.item = {
                        invoiceSNList: $scope.invoiceSNList,
                        lIsSlected: $scope.lIsSlected,
                        // invoiceList: $scope.invoiceList,
                        status: 2,

                    }
                    const modalInstance = $uibModal.open({
                        templateUrl: 'chooseInvoiceNoCtrl.html',
                        controller: 'chooseInvoiceNoCtrl',
                        openedClass: 'mod-modal mod-modal-lg',
                        backdrop: 'static',
                        resolve: {
                            items1() {
                                return $scope.item
                            },
                        },
                    })
                    modalInstance.result.then((merge) => {
                        $scope.invoiceList.push(merge)
                        fn()
                        $scope.lIsSlected = []
                        $scope.tb_isAllselected = false
                        $scope.tb_isAllselected2 = false
                    }, () => {


                    })
                } else {
                    logger.logError('必须商品税率、名称、规格型号、计量单位一致的商品才允许合并')
                }
            }
        }
        // 提交前限额校验
        function quotaCheckOut() {
            $scope.commitDataList = []
            // 判断明细是否全部拆分
            if ($scope.qryBillDetail.list.length > 0) {
                logger.logError('请将所有的明细都拆分，再进行生成发票操作!')
                return false
            }

            // 将右侧发票按照发票序号分组,计算金额
            const map = {}
            let totle = 0
            const sn = []
            for (let i = 0; i < $scope.invoiceList.length; i++) {
                const ai = $scope.invoiceList[i]
                if (!map[ai.invoiceSN]) {
                    $scope.commitDataList.push({
                        invoiceSN: ai.invoiceSN,
                        data: [ai],
                    })
                    map[ai.invoiceSN] = ai
                } else {
                    for (let j = 0; j < $scope.commitDataList.length; j++) {
                        const dj = $scope.commitDataList[j]
                        if (dj.invoiceSN == ai.invoiceSN) {
                            dj.data.push(ai)
                            break
                        }
                    }
                }
            }
            for (const a in $scope.commitDataList) {
                for (const b in $scope.commitDataList[a].data) {
                    totle = globalFn.Add(totle, $scope.commitDataList[a].data[b].amount)
                }

                if (totle > $scope.quota) {
                    sn.push($scope.commitDataList[a].invoiceSN)
                }
                totle = 0
            }
            if (sn.length > 0) {
                layer.alert(`发票序号为${sn.join(',')}超出限额`)
            } else {
                return true
            }
        }
        $scope.spiltBillCommit = function () {
            if (!checkSunInfo($scope.initBillInfo)) return
            getInvoiceSNList() // 获取发票序号组

            const CommitObj = {
                billId,
                commitDetailList: $scope.invoiceList,
                forceDetailFlag: $scope.forceDetailFlag,
            }
            if (quotaCheckOut()) {
                httpRequest.post_spiltBill(CommitObj).then((res) => {
                    $scope.succ = {
                        commitDataList: $scope.commitDataList,
                    }
                    const modalInstance = $uibModal.open({
                        templateUrl: 'spiltBillCommitModCtrl.html',
                        controller: 'spiltBillCommitModCtrl',
                        openedClass: 'mod-modal mod-modal-lg',
                        backdrop: 'static',
                        resolve: {
                            items1() {
                                return $scope.succ
                            },
                        },
                    })
                    modalInstance.result.then(() => {
                        $state.go('outputManage.FOManage.ovatBill.list')
                    }, () => {})
                })
            }
        }
        httpRequest.get_isShowManualSpilt(billId).then((res) => {
            $scope.btnshow = res.data.value
        })
        // 点击展开
        $scope.clickExpand = function () {
            $scope.isExpand = !$scope.isExpand
        }
    }
}

billDetailListCtrl.$inject = ["$scope", "$uibModal", "logger", "httpRequest", "$state", "$stateParams", "dictService", "globalFn"];
export default billDetailListCtrl;


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/ovatBill/billDetailListCtrl.js